import { Component, OnInit } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { Router } from '@angular/router';
import { ScreeningReport } from '../models/screening-report.model';
import { SurveyQuestion } from '../models/survey-question.model';
import { LocalstorageService } from '../services/localstorage.service';
import { SurveyService } from '../services/survey.service';

@Component({
  selector: 'app-covid-exposure',
  templateUrl: './covid-exposure.component.html',
  styleUrls: ['./covid-exposure.component.css']
})
export class CovidExposureComponent implements OnInit {
  private screeningReportModel: ScreeningReport;
  isExposureReportedInLast7Days: any;

  currentQuestion = {
    "answerText": "",
    "dataTypeName": "radio",
    "options": [
      {
        "listName": "RadioOption",
        "optionId": "Yes",
        "optionValue": "Yes"
      },
      {
        "listName": "RadioOption",
        "optionId": "No",
        "optionValue": "No"
      }
    ],
    "questionFieldName": "CovidExposureReported",
    "questionId": 395,
    "questionText": "You have reported an exposure or symptoms to EOH in the past 7 days.   Do you want to report an additional exposure, or do you have a new onset of symptoms or a new positive test result that hasn't already been reported?",
  }

  get isLastPSSResultFail(){
    if(this.screeningReportModel){
      return this.screeningReportModel.resultType == 'Fail';
    }
  }

  constructor(private router: Router,
    private surveyService: SurveyService,
    private localstorageService: LocalstorageService) { }

  async ngOnInit() {
    let authDetails = this.localstorageService.getAuth();
    const {isExposureReportedInLast7Days } = await this.surveyService.getExposureDetails(authDetails.employeeInfo.corpId).toPromise();
    this.isExposureReportedInLast7Days = isExposureReportedInLast7Days;

    this.surveyService.getScreeningReport(authDetails.employeeInfo.corpId).subscribe(responseData =>{
      this.screeningReportModel = responseData;
    }, error=> console.log(error));
  }

  startNewScreening(){
    this.router.navigateByUrl('/covid-exposure');
  }

  stopScreening(){
    this.router.navigateByUrl('/covid-exposure');
  }

  onContinueClicked() {
    this.router.navigateByUrl('/survey/covidexposure');
  }

  onRadioChanged(event: MatRadioChange, currentQuestion: SurveyQuestion, selectedRadioText: string) {
    if (this.currentQuestion.answerText == 'No'){
    }
  }

  startPSSScreening(){
    this.router.navigateByUrl('/screening/pre-shift');
  }
}
